import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/shadcn/tooltip";
import Column from "@/components/Ui/Column";
import Row from "@/components/Ui/Row";
import VendorLink from "@/components/VendorLink";
import { Pencil } from "lucide-react";
import { ReactNode } from "react";

type InfoItem = [string, ReactNode];

type Props = {
  items: InfoItem[];
  editHrefs?: Record<string, string>;
};

const InfoList = ({ items = [], editHrefs }: Props) => {
  return (
    <Column className="w-full gap-3" left>
      {items.map(([key, value], index) => {
        const editHref = editHrefs?.[key];
        return (
          <Column
            key={index}
            className="w-full min-w-0 gap-0.5"
            left
            data-testid={`User ${key.toLowerCase()}`}
          >
            <Row left className="w-full">
              <div className="text-muted-foreground text-sm">{key}</div>
              {editHref && (
                <Tooltip>
                  <TooltipTrigger asChild>
                    <VendorLink
                      href={editHref}
                      aria-label={`Edit ${key}`}
                      className="text-muted-foreground/50 hover:text-muted-foreground -mt-px px-2 transition-colors"
                    >
                      <Pencil className="size-4" />
                    </VendorLink>
                  </TooltipTrigger>
                  <TooltipContent>Edit</TooltipContent>
                </Tooltip>
              )}
            </Row>
            <div className="w-full min-w-0 truncate text-sm">{value}</div>
          </Column>
        );
      })}
    </Column>
  );
};

export default InfoList;
